module.exports = __webpack_public_path__ + "img/gall-10.0a87e211.jpg";